import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import MaterialReactTable from 'material-react-table';
import TableContainer from '@mui/material/TableContainer';
import { Grid } from '@material-ui/core';
import { showProgress } from '../../redux/actions/DealershipActions';
import service from '../../apis/service';
import { ErrorToast, notifySuccess } from '../utils/Utils';
import erColumns from './ErTableColumns';
import ReportTab from './ReportTab';
import { apiEndpoints } from '../../constants/apiEndpoints';
import useFetchData from './hooks/useFetchData';
import ShowProgress from '../ui/Backdrop';

const useStyles = makeStyles(() => ({
  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  reportFrame: {
    width: 'auto',
    height: 'auto',
    left: '316px',
    top: '182px',
    background: '#F7F7F7',
    padding: '10px',
    // overflowY:"auto",
    // "&::-webkit-scrollbar": { width: "10px" },
    // "&::-webkit-scrollbar-track": {
    //   boxShadow: "inset 0 0 5px grey",
    //   borderRadius: "20px",
    // },
    // "&::-webkit-scrollbar-thumb": {
    //   background: "lightGrey",
    //   borderRadius: "100px",
    // },
  },
  title: {
    marginLeft: '22px',
    marginBottom: '12px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
    display: 'flex',
    alignItems: 'center',
    color: '#000000',
  },
  subtitle: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '10px',
    lineHeight: '12px',
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(0, 0, 0, 0.4)',
  },
  periodField: {
    width: '400px',
    height: '38px',
    background: '#FEFEFE',
    border: '1px solid #F4F4F4',
    marginRight: '22px',
  },
  emailField: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    marginRight: '24px',
    paddingLeft: '10px',
    paddingTop: '10px',
    alignItems: 'center',
    height: '26px',
    background: '#FEFEFE',
    border: '1px solid #F4F4F4',
  },
  dealLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    marginLeft: '22px',
    marginBottom: '10px',
  },
  rangeLabel: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    marginBottom: '10px',
  },
  emailLabel: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    marginBottom: '3px',
  },
  sendBtn: {
    width: '121px',
    height: '42px',
    marginTop: '17px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '14px',
    lineHeight: '17px',
    textAlign: 'center',
    marginLeft: '22px',
  },
}));
const Report = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const periodArr = ['Last Month', 'Last Week', 'This Week', 'This Month', 'Custom Date'];
  const dealList = useSelector((state) => state.GetDealershipList.dealershiplist);
  const [options, setOptions] = useState([]);
  const [erData, setErData] = useState([]);
  const [erTitle, setErTitle] = useState('');

  const [selectedOption, setSelectedOption] = useState('');
  const [selectedExam, setSelectedExam] = useState('');
  const [dealIds, setDealIds] = useState([]);
  const [email, setEmail] = useState('');
  const [period, setPeriod] = useState(1);
  const [periodIndex, setPeriodIndex] = useState(0);
  const [openCustomDate, setOpenCustomDate] = useState(false);
  const [selectionRange, setSelectionRange] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const [selectedOptionEr, setSelectedOptionEr] = useState({});
  const [emailEr, setEmailEr] = useState('');
  const [periodEr, setPeriodEr] = useState(1);
  const [periodIndexEr, setPeriodIndexEr] = useState(0);
  const [openCustomDateEr, setOpenCustomDateEr] = useState(false);
  const [selectionRangeEr, setSelectionRangeEr] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const [selectedOptionTOM, setSelectedOptionTOM] = useState({});
  const [emailTOM, setEmailTOM] = useState('');
  const [periodTOM, setPeriodTOM] = useState(1);
  const [periodIndexTOM, setPeriodIndexTOM] = useState(0);
  const [openCustomDateTOM, setOpenCustomDateTOM] = useState(false);
  const [selectionRangeTOM, setSelectionRangeTOM] = useState({
    startDate: new Date(),
    endDate: new Date(),
    key: 'selection',
  });

  const { dealershipHierarchyList, examList } = useFetchData();

  const formatDate = (date) => {
    const d = new Date(date);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    const year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  };

  const handleSelect = (ranges) => {
    setSelectionRange(ranges.selection);
  };

  const handleSelectEr = (ranges) => {
    setSelectionRangeEr(ranges.selection);
  };

  const handleSelectTOM = (ranges) => {
    setSelectionRangeTOM(ranges.selection);
  };

  const handleChange = (selectedOpt) => {
    setSelectedOption(selectedOpt);
    let dealTemp = [];
    selectedOpt
      ?.filter((i) => i.value !== '*')
      .forEach((option) => {
        const id = dealList?.filter((obj) => obj.name === option.label)[0].id;
        dealTemp = [...dealTemp, id];
      });
    setDealIds(dealTemp);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleEmailChangeEr = (e) => {
    setEmailEr(e.target.value);
  };

  const handleEmailChangeTOM = (e) => {
    setEmailTOM(e.target.value);
  };

  const handleChangePeriod = (e) => {
    const val = parseInt(e.target.value, 10) + 1;
    setPeriod(val);
    setPeriodIndex(parseInt(e.target.value, 10));
    if (parseInt(e.target.value, 10) === 4) {
      setOpenCustomDate(true);
    } else {
      setOpenCustomDate(false);
    }
  };

  const handleChangePeriodEr = (e) => {
    const val = parseInt(e.target.value, 10) + 1;
    setPeriodEr(val);
    setPeriodIndexEr(parseInt(e.target.value, 10));
    if (parseInt(e.target.value, 10) === 4) {
      setOpenCustomDateEr(true);
    } else {
      setOpenCustomDateEr(false);
    }
  };

  const handleChangePeriodTOM = (e) => {
    const val = parseInt(e.target.value, 10) + 1;
    setPeriodTOM(val);
    setPeriodIndexTOM(parseInt(e.target.value, 10));
    if (parseInt(e.target.value, 10) === 4) {
      setOpenCustomDateTOM(true);
    } else {
      setOpenCustomDateTOM(false);
    }
  };

  const closeCustomRange = () => {
    setOpenCustomDate(false);
  };

  const closeCustomRangeEr = () => {
    setOpenCustomDateEr(false);
  };

  const closeCustomRangeTOM = () => {
    setOpenCustomDateTOM(false);
  };

  const submit = async () => {
    dispatch(showProgress(true));
    const startDate = formatDate(selectionRange.startDate);
    const endDate = formatDate(selectionRange.endDate);
    let data = '';
    if (period === 5) {
      data = JSON.stringify({
        dealershipIds: dealIds,
        fromdate: startDate,
        todate: endDate,
        type: period,
        email,
      });
    } else {
      data = JSON.stringify({
        dealershipIds: dealIds,
        type: period,
        email,
      });
    }
    await service
      .post(apiEndpoints.REPORT_REPORTS, data)
      .then(() => {
        notifySuccess('Email Sent Successfully');
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };
  const submitEx = async () => {
    const obj = examList?.find((exam) => exam.id === selectedExam);
    const payload = { examId: obj.id, examName: obj.name };
    await service
      .post(apiEndpoints.REPORT_EXAMS, payload)
      .then(() => {
        notifySuccess('Email Sent Successfully');

        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };
  const submitEr = async () => {
    setErData([]);
    setErTitle('');
    dispatch(showProgress(true));
    const startDate = formatDate(selectionRangeEr.startDate);
    const endDate = formatDate(selectionRangeEr.endDate);
    let filters = '';
    if (periodEr === 5) {
      filters = JSON.stringify({
        filters: {
          ...(Object.keys(selectedOptionEr).length ? { dealerships: selectedOptionEr } : {}),
          trendRequired: false,
          time: {
            startDate,
            endDate,
            type: periodEr,
          },
        },
        ...(emailEr ? { emails: [emailEr] } : {}),
      });
    } else {
      filters = JSON.stringify({
        filters: {
          ...(Object.keys(selectedOptionEr).length ? { dealerships: selectedOptionEr } : {}),
          trendRequired: false,
          time: {
            type: periodEr,
          },
        },
        ...(emailEr ? { emails: [emailEr] } : {}),
      });
    }
    await service
      .post(Object.keys(selectedOptionEr).length ? apiEndpoints.REPORT_ER_HIERARCHY : apiEndpoints.REPORT_ER, filters)
      .then((response) => {
        setErData(response.list || []);
        setErTitle(
          `Partner Experience Report for ${response.filters.time.startDate} to ${response.filters.time.endDate}`,
        );
        if (emailEr) {
          notifySuccess('Email Sent Successfully');
        }
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };
  const handleExamChange = ({ target: { value } }) => {
    setSelectedExam(value);
  };
  const submitTOM = async () => {
    dispatch(showProgress(true));
    const startDate = formatDate(selectionRangeTOM.startDate);
    const endDate = formatDate(selectionRangeTOM.endDate);
    const dealershipIds = [];
    if (!_isEmpty(selectedOptionTOM)) {
      Object.keys(selectedOptionTOM).forEach((key) => {
        dealershipIds.push(parseInt(key, 10));
        dealershipIds.push(...selectedOptionTOM[key]);
      });
    }
    let filters = '';
    if (periodTOM === 5) {
      filters = JSON.stringify({
        filters: {
          ...(dealershipIds.length ? { dealerships: dealershipIds } : {}),
          time: {
            startDate,
            endDate,
            type: periodTOM,
          },
        },
        ...(emailTOM ? { email: emailTOM } : {}),
      });
    } else {
      filters = JSON.stringify({
        filters: {
          ...(dealershipIds.length ? { dealerships: dealershipIds } : {}),
          time: {
            type: periodTOM,
          },
        },
        ...(emailTOM ? { email: emailTOM } : {}),
      });
    }
    await service
      .post(apiEndpoints.REPORT_CHECKIN_REPORT, filters)
      .then((response) => {
        if (response.message) {
          notifySuccess(response.message);
        }
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  useEffect(() => {
    const tempArr = [];
    dealList?.forEach((deal) => {
      tempArr.push({ value: deal.id, label: deal.name });
    });
    setOptions(tempArr);
  }, [dealList]);

  return (
    <Grid>
      <ReportTab
        title="Usage Report"
        selectedOption={selectedOption}
        classes={classes}
        handleChange={handleChange}
        options={options}
        periodIndex={periodIndex}
        handleChangePeriod={handleChangePeriod}
        periodArr={periodArr}
        email={email}
        openCustomDate={openCustomDate}
        selectionRange={selectionRange}
        closeCustomRange={closeCustomRange}
        submit={submit}
        handleSelect={handleSelect}
        handleEmailChange={handleEmailChange}
      />
      <br />
      <br />
      <ReportTab
        title="TOM Report"
        selectedOption={selectedOptionTOM}
        classes={classes}
        handleChange={setSelectedOptionTOM}
        options={dealershipHierarchyList}
        periodIndex={periodIndexTOM}
        handleChangePeriod={handleChangePeriodTOM}
        periodArr={periodArr}
        email={emailTOM}
        openCustomDate={openCustomDateTOM}
        selectionRange={selectionRangeTOM}
        closeCustomRange={closeCustomRangeTOM}
        submit={submitTOM}
        handleSelect={handleSelectTOM}
        handleEmailChange={handleEmailChangeTOM}
        dealershipRequired={false}
        emailRequired={false}
        dealershipPlaceholder="All Dealerships"
        pxReport
      />
      <br />
      <br />
      <ReportTab
        title="Exam Question Analysis Report"
        classes={classes}
        selectedOption={selectedExam}
        handleExamChange={handleExamChange}
        options={examList}
        submit={submitEx}
        dealershipRequired={false}
        emailRequired={false}
        pxReport={false}
        examReport
      />
      <br />
      <br />
      <ReportTab
        title="Partner Experience Report"
        selectedOption={selectedOptionEr}
        classes={classes}
        handleChange={setSelectedOptionEr}
        options={dealershipHierarchyList}
        periodIndex={periodIndexEr}
        handleChangePeriod={handleChangePeriodEr}
        periodArr={periodArr}
        email={emailEr}
        openCustomDate={openCustomDateEr}
        selectionRange={selectionRangeEr}
        closeCustomRange={closeCustomRangeEr}
        submit={submitEr}
        handleSelect={handleSelectEr}
        handleEmailChange={handleEmailChangeEr}
        dealershipRequired={false}
        emailRequired={false}
        dealershipPlaceholder="All Dealerships"
        pxReport
      />
      {erData && erData.length ? (
        <Grid container direction="row">
          <Grid item>
            <h2>{erTitle}</h2>
          </Grid>
          <Grid item xs={12}>
            <Grid container direction="row">
              <Grid item xs={12}>
                <TableContainer style={{ maxWidth: '72vw' }}>
                  <MaterialReactTable
                    columns={erColumns}
                    data={erData}
                    enableColumnActions
                    enableColumnFilters
                    enablePagination={false}
                    enableSorting
                    enableBottomToolbar={false}
                    enableTopToolbar
                    enableFullScreenToggle
                    muiTableBodyRowProps={{ hover: true }}
                    enableStickyHeader
                    enableMultiRowSelection={false}
                    rowCount={erData.length}
                    enablePinning
                    enableMultiSort
                    enableColumnResizing
                    enableDensityToggle={false}
                    initialState={{ density: 'compact' }}
                    muiTableProps={{
                      sx: {
                        tableLayout: 'fixed',
                      },
                    }}
                  />
                </TableContainer>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : null}
      <br />
      <br />
      <ShowProgress />
    </Grid>
  );
};

export default Report;
